import Container from './edit-about-container';

export default Container;
